export const TOOLTIP_PAGE_PAGE_TOOLS: string  = "To enable this feature select one or more records.";
export const TOOLTIP_RECENT_SEARCH: string    = "Recent searches is not available in this section.";
export const TOOLTIP_PDF_SEARCH: string    = "Search is not available or in the process of loading.";

